"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _tslib = require("tslib");
var _themeUi = require("theme-ui");

/** @jsx jsx */
var Progress = function Progress(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return (0, _themeUi.jsx)(_themeUi.Progress, (0, _tslib.__assign)({
    variant: "progress." + variant
  }, props));
};
Progress.displayName = 'Progress';
var _default = Progress;
exports.default = _default;